import moment from 'moment';

export default function (date) {
	return moment().year(2499).isBefore(date);
}
